
import { RoleModalNames } from "./role.modal.name";
import RoleModalCreate from "../page/components/role.modal.create";
import { RoleControllerState, RoleControllerAction } from "../controller/role.controller";
import RoleModalUpdate from "../page/components/role.modal.update";
import RoleModalPermissions from "../page/components/role.modal.permissions";

export interface RoleChildrenModel {
    name: RoleModalNames;
    child: ({ ctrl }: { ctrl: RoleControllerState & RoleControllerAction }) => JSX.Element,
}
export const RoleModalChildrenData: RoleChildrenModel[] = [
    {
        name: RoleModalNames.CREATE,
        child: ({ ctrl }: { ctrl: RoleControllerState & RoleControllerAction }) => <RoleModalCreate ctrl={ctrl} />,
    },
    {
        name: RoleModalNames.UPDATE,
        child: ({ ctrl }: { ctrl: RoleControllerState & RoleControllerAction }) => <RoleModalUpdate ctrl={ctrl} />,
    },
    {
        name: RoleModalNames.PERMISSIONS,
        child: ({ ctrl }: { ctrl: RoleControllerState & RoleControllerAction }) => <RoleModalPermissions ctrl={ctrl} />,
    },
]